import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageStatus } from '@/models'

export interface GetPackagesCountsByClientRequest {
  buildingId?: number
  search?: string
  fromDate?: number
  toDate?: number
  status?: PackageStatus
  carrier?: string[]
  perishable?: string
  locations?: string[]
  limit?: number
  skip?: number
}

interface PackagesCountByClient {
  clientId: number
  name: string
  count: number
}

export interface GetPackagesCountsByClientResponse {
  data: PackagesCountByClient[]
  total: number
  skip: number
  limit: number
  hasMore: boolean
}

export const PACKAGES_COUNTS_BY_CLIENT_BASE_QUERY_KEY = 'useGetPackagesCountsByClient'
export const getPackagesCountsByClientQueryKey = (data: GetPackagesCountsByClientRequest) => [
  PACKAGES_COUNTS_BY_CLIENT_BASE_QUERY_KEY,
  data,
]

export const getPackagesCountsByClient = async (
  params: GetPackagesCountsByClientRequest,
  signal?: AbortSignal,
): Promise<GetPackagesCountsByClientResponse> => {
  const { buildingId, fromDate, toDate, locations, ...rest } = params
  const response = await authAPI.get<GetPackagesCountsByClientResponse>(
    `/packages/counts/${buildingId}/client`,
    {
      params: {
        ...rest,
        endDate: toDate,
        location: locations?.length ? locations.join(',') : undefined,
        startDate: fromDate,
      },
      signal,
    },
  )
  return response.data
}

export const useGetPackagesCountsByClient = (data: GetPackagesCountsByClientRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPackagesCountsByClient(data, signal),
    queryKey: getPackagesCountsByClientQueryKey(data),
  })
}
